module.exports = __webpack_public_path__ + "static/media/cwc-logo-white-v1-1.db41ac24.png";